export const translations = {
  it: {
    code: "it",
    nav: {
      products: "Prodotti",
      features: "Funzioni",
      pricing: "Prezzi",
      manifesto: "Manifesto",
      contact: "Contatti",
      demo: "Demo",
      cta: "Richiedi una demo",
      admin: "Area riservata",
    },
    hero: {
      overline: "SUITE COMPLETA ED OPERATIVA PER LA RISTORAZIONE",
      line1: "Il tuo ristorante,",
      line2: "sincronizzato",
      line3: "al secondo.",
      sub: "Magazzino, personale e comande di cucina e bar in un unico organismo digitale. SOR trasforma il caos del servizio in un flusso preciso, misurabile e redditizio.",
      ctaPrimary: "Calcola il tuo abbonamento",
      ctaSecondary: "Scopri i prodotti",
      stat1: "−31% sprechi di magazzino",
      stat2: "3 min tempo medio comanda",
      stat3: "100% servizio sotto controllo",
    },
    impact: {
      overline: "L'IMPATTO SOR",
      germany: { value: 79, label: "Ristoranti in Germania usano SOR oggi" },
      world: { value: 159, label: "Ristoranti nel mondo" },
      saved: { start: 4870000, label: "Euro risparmiati dai nostri clienti", prefix: "€" },
      sara: {
        tag: "INTELLIGENZA ARTIFICIALE",
        name: "S.A.R.A",
        title: "L'intera struttura del ristorante sotto il controllo dell'IA più evoluta al mondo",
        body: "S.A.R.A sorveglia ogni reparto in tempo reale. Attraverso le telecamere misura i tempi effettivi di preparazione in cucina, monitora l'operatività dei cuochi e verifica che ogni piatto esca sempre identico allo standard. Nulla le sfugge: qualità costante, servizio impeccabile.",
        points: [
          "Tempi reali di preparazione monitorati via telecamera",
          "Operatività e resa di ogni cuoco sotto analisi continua",
          "Controllo qualità: ogni piatto sempre uguale in uscita",
        ],
      },
      sensing: {
        tag: "SARA SENSING",
        title: "Il ristorante che percepisce. Senza telecamere.",
        body: "Sara Sensing trasforma i segnali WiFi del tuo locale in rilevamento di presenza e parametri vitali, attraverso i muri, senza telecamere né dispositivi indossabili. Le micro-onde emesse dal WiFi diventano un radar invisibile che sente tutto ciò che accade dentro il ristorante.",
        detects: [
          { t: "Presenza e occupazione", d: "Conta le persone e traccia entrate e uscite in ogni ambiente." },
          { t: "Respiro e battito cardiaco", d: "Rilevamento contactless dei parametri vitali, senza alcun contatto." },
          { t: "Movimenti e transizioni", d: "Segue gli spostamenti e i passaggi tra una stanza e l'altra." },
          { t: "Stati semantici", d: "Capisce se qualcuno dorme, se una stanza è attiva o il bagno è occupato." },
          { t: "Sicurezza e allerta", d: "Riconosce rischio caduta o assenza di movimento e lancia l'allarme." },
        ],
      },
    },
    marquee: "GESTIONE MAGAZZINO · TEAM MANAGER · KITCHEN DISPLAY · BAR BOARD · COMANDE LIVE · PIN SICURO · FOOD COST · TURNI · ",
    productsSection: {
      overline: "L'ECOSISTEMA",
      title: "Tre applicazioni. Un solo cervello.",
      sub: "Ogni modulo lavora da solo o insieme agli altri. Attivi solo ciò che ti serve, paghi solo le ore che usi.",
      whyLabel: "Perché è importante",
      onlyLabel: "Solo SOR può farlo",
      featuresLabel: "Cosa fa",
    },
    products: [
      {
        id: "gestionale",
        domain: "gestionale.sor.de",
        name: "Gestionale",
        tagline: "Il magazzino che si conta da solo.",
        description:
          "Controllo totale di scorte, fornitori e food cost in tempo reale. Sai sempre cosa hai, cosa manca e quanto ti costa ogni piatto.",
        features: [
          { title: "Inventario in tempo reale", desc: "Ogni carico e scarico aggiorna le giacenze all'istante, senza fogli Excel." },
          { title: "Food cost per piatto", desc: "Il costo esatto di ogni ricetta, ricalcolato ad ogni variazione di prezzo del fornitore." },
          { title: "Ordini fornitori intelligenti", desc: "Soglie minime automatiche e proposte d'ordine basate sui consumi reali." },
          { title: "Scadenze e HACCP", desc: "Lotti, scadenze e tracciabilità pronti per qualsiasi controllo sanitario." },
        ],
        whyMatters:
          "Il margine di un ristorante si vince o si perde in magazzino. Senza dati precisi, ogni piatto è una scommessa: sprechi invisibili, ordini a sensazione e food cost che erode l'utile mese dopo mese.",
        onlyUs:
          "Solo SOR collega il magazzino direttamente alle comande di cucina: ogni piatto servito scala automaticamente gli ingredienti dalle scorte. Zero doppie digitazioni, inventario sempre vero.",
      },
      {
        id: "team",
        domain: "team.sor.de",
        name: "Team Manager",
        tagline: "Il tuo staff, orchestrato.",
        description:
          "Turni, presenze e comunicazioni in un unico terminale. Gli amministratori pianificano, i dipendenti timbrano con un PIN personale.",
        features: [
          { title: "Turni drag & drop", desc: "Costruisci la settimana in pochi minuti e la squadra la vede sul telefono." },
          { title: "Timbrature con PIN", desc: "Entrata e uscita da terminale dedicato, senza badge da smarrire." },
          { title: "Costo del lavoro live", desc: "Vedi in tempo reale quanto costa ogni servizio rispetto all'incasso previsto." },
          { title: "Ferie e permessi", desc: "Richieste, approvazioni e saldi ore gestiti senza un solo messaggio WhatsApp." },
        ],
        whyMatters:
          "Il personale è la voce di costo più alta e più difficile da controllare. Turni fatti a mano generano buchi di servizio, straordinari non pagati e conflitti che fanno scappare i migliori.",
        onlyUs:
          "Solo SOR incrocia il costo del lavoro con l'andamento reale delle comande: se la sala si svuota, il sistema ti avvisa che stai spendendo troppo in quel momento esatto.",
      },
      {
        id: "kitchen",
        domain: "pac.sor.de/kitchen",
        name: "PAC · Kitchen Board",
        tagline: "La cucina che non perde un colpo.",
        description:
          "Il Kitchen Display System che sostituisce lo scontrino di carta. Le comande arrivano ordinate, colorate per priorità e cronometrate.",
        features: [
          { title: "Comande live per postazione", desc: "Ogni partita vede solo i suoi piatti, nell'ordine giusto di uscita." },
          { title: "Timer e ritardi a colori", desc: "Il tempo di preparazione diventa verde, giallo, rosso: nessun tavolo dimenticato." },
          { title: "Bump & recall istantaneo", desc: "Un tocco per completare, un tocco per recuperare. Zero carta, zero errori." },
          { title: "Sincronia sala-cucina", desc: "Modifiche, note allergeni e conti separati arrivano puliti sullo schermo." },
        ],
        whyMatters:
          "In cucina un secondo perso è un tavolo che si raffredda. Gli scontrini di carta si perdono, si strappano e non dicono mai quanto tempo è passato davvero.",
        onlyUs:
          "Solo SOR cronometra ogni piatto dal momento dell'ordine e impara i tuoi tempi reali, mostrandoti dove il servizio rallenta prima che il cliente se ne accorga.",
      },
      {
        id: "bar",
        domain: "pac.sor.de/bar",
        name: "PAC · Bar Board",
        tagline: "Il bancone sempre un passo avanti.",
        description:
          "Il display dedicato al bar: cocktail, caffetteria e bevande gestiti in coda separata dalla cucina, con le stesse regole di velocità.",
        features: [
          { title: "Coda bar indipendente", desc: "Le bevande non aspettano i piatti: escono al ritmo del bancone." },
          { title: "Priorità aperitivo", desc: "Ordini rapidi e round multipli riconosciuti e raggruppati automaticamente." },
          { title: "Ricette a schermo", desc: "Dosi e preparazioni dei cocktail sempre visibili al barista di turno." },
          { title: "Sincronia con il conto", desc: "Ogni bevanda servita è già sul conto del tavolo, senza ridigitare nulla." },
        ],
        whyMatters:
          "Il bar è dove si fanno i margini più alti, ma anche dove si crea la coda che rovina la serata. Senza un flusso dedicato, cucina e bancone si intasano a vicenda.",
        onlyUs:
          "Solo SOR separa fisicamente il flusso bar da quello cucina mantenendoli sullo stesso conto: due velocità diverse, un unico scontrino perfetto.",
      },
    ],
    manifesto: {
      overline: "IL MANIFESTO",
      title: "Perché esiste SOR",
      chapters: [
        { n: "01", title: "I dati prima delle sensazioni", body: "Un ristorante non si governa a intuito. Ogni scelta — un ordine, un turno, un piatto — deve poggiare su un numero vero, aggiornato al secondo." },
        { n: "02", title: "Un solo sistema, non dieci app", body: "Magazzino, personale e comande parlano la stessa lingua. La frammentazione è il vero nemico del margine." },
        { n: "03", title: "Paghi ciò che usi", body: "Niente licenze annuali gonfiate. Attivi le ore che ti servono, quando ti servono, e le spegni in bassa stagione." },
        { n: "04", title: "Velocità come cultura", body: "Il software deve sparire nel servizio: un tocco, una comanda, un piatto. Tutto il resto è rumore." },
      ],
    },
    testimonials: {
      overline: "STORIE DALLA SALA",
      title: "Ristoranti che non tornano più indietro",
      items: [
        { quote: "Da quando la cucina lavora con la Kitchen Board abbiamo tagliato i tempi di uscita del 40%. I camerieri non urlano più le comande: leggono lo schermo e basta.", author: "Luca Ferrari", role: "Patron", restaurant: "Osteria del Porto", city: "Amburgo", rating: 5 },
        { quote: "Il food cost per piatto in tempo reale mi ha aperto gli occhi: ho scoperto tre piatti che mi facevano perdere soldi. In un mese ho recuperato il costo dell'abbonamento.", author: "Sofia Greco", role: "Chef & Titolare", restaurant: "Marea Bistrot", city: "Berlino", rating: 5 },
        { quote: "Con il Team Manager i turni si fanno in venti minuti e vedo subito quanto mi costa ogni serata. Pagare le app a ore, solo quando apro, è geniale.", author: "Marco Bianchi", role: "General Manager", restaurant: "Trattoria 1985", city: "Monaco", rating: 5 },
        { quote: "Il bar aveva sempre code infinite. Con la Bar Board separata dalla cucina serviamo gli aperitivi al doppio della velocità, sullo stesso conto.", author: "Elena Rossi", role: "Bar Manager", restaurant: "Laguna Cocktail Bar", city: "Colonia", rating: 5 },
      ],
    },
    pricing: {
      overline: "CALCOLATORE",
      title: "Costruisci il tuo abbonamento a ore",
      sub: "Scegli le app, imposta le ore al giorno e i giorni a settimana. Il prezzo si calcola sull'uso reale — a partire da 2 €/ora.",
      selectApps: "Seleziona le applicazioni",
      hoursPerDay: "Ore al giorno",
      daysPerWeek: "Giorni a settimana",
      billing: "Fatturazione",
      weekly: "Settimanale",
      monthly: "Mensile",
      perHour: "/ora",
      estimateLabel: "Il tuo preventivo",
      savingsLabel: "Risparmio stimato/mese",
      netLabel: "Beneficio netto/mese",
      monthlyHoursLabel: "Ore operative al mese",
      savingsHint: "Stima basata sulle ore mensili di utilizzo: meno sprechi, cucina più efficiente e costo del lavoro ottimizzato.",
      weeklyCost: "Costo settimanale",
      monthlyCost: "Costo mensile",
      hours: "ore",
      days: "giorni",
      noApps: "Seleziona almeno un'applicazione per vedere il preventivo.",
      requestCta: "Richiedi questo piano",
      breakdown: "Dettaglio",
      plansTitle: "Oppure parti da un pacchetto pronto",
      plansSub: "Configurazioni consigliate, sempre modificabili a ore.",
      mostPopular: "Più scelto",
      includes: "Include",
      choosePlan: "Scegli",
    },
    plans: {
      starter: { name: "Starter", desc: "Il controllo del magazzino per chi parte." },
      team: { name: "Team", desc: "Magazzino + gestione completa del personale." },
      kitchen: { name: "Kitchen Pro", desc: "Aggiungi il Kitchen Display alla tua cucina." },
      full: { name: "Full Suite", desc: "Tutto, cucina e bar sincronizzati." },
    },
    appNames: {
      gestionale: "Gestionale",
      team: "Team Manager",
      kitchen: "Kitchen Board",
      bar: "Bar Board",
    },
    contact: {
      overline: "PARLIAMONE",
      title: "Porta SOR nel tuo ristorante",
      sub: "Lascia i tuoi dati: prepariamo una demo su misura e ti mostriamo il preventimo esatto per la tua attività.",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono",
      restaurant: "Nome del ristorante",
      message: "Raccontaci le tue esigenze",
      submit: "Invia richiesta",
      sending: "Invio in corso...",
      success: "Richiesta inviata! Ti contatteremo a breve.",
      error: "Qualcosa è andato storto. Riprova.",
      estimateNote: "Preventivo allegato dal calcolatore",
    },
    booking: {
      overline: "PRENOTA UNA DEMO",
      title: "Riserva la tua fascia oraria",
      sub: "Scegli il giorno e l'orario: un nostro consulente ti mostrerà SOR dal vivo, con S.A.R.A in azione.",
      dateLabel: "Scegli il giorno",
      timeLabel: "Scegli l'orario",
      name: "Nome e cognome",
      email: "Email",
      restaurant: "Ristorante",
      notes: "Note (opzionale)",
      submit: "Prenota la demo",
      sending: "Prenotazione...",
      success: "Demo prenotata! Ti confermeremo via email.",
      error: "Qualcosa è andato storto. Riprova.",
      selectDatePrompt: "Seleziona una data dal calendario",
      selectTimePrompt: "Seleziona un orario disponibile",
      chosen: "La tua scelta",
      slotTaken: "Occupato",
    },
    footer: {
      tagline: "Suite Completa ed Operativa Per La Ristorazione.",
      rights: "Tutti i diritti riservati.",
      product: "Prodotto",
      company: "Azienda",
    },
    admin: {
      title: "Area riservata",
      pinPrompt: "Inserisci il PIN per accedere",
      pin: "PIN",
      enter: "Accedi",
      wrongPin: "PIN non valido",
      dashboard: "Dashboard Lead",
      totalLeads: "Lead totali",
      newLeads: "Nuovi",
      potentialRevenue: "Ricavo potenziale/mese",
      appInterest: "Interesse per app",
      leadsList: "Richieste ricevute",
      colName: "Nome",
      colContact: "Contatto",
      colRestaurant: "Ristorante",
      colApps: "App",
      colEstimate: "Preventivo",
      colStatus: "Stato",
      colDate: "Data",
      colActions: "Azioni",
      logout: "Esci",
      noLeads: "Ancora nessuna richiesta.",
      bookingsList: "Prenotazioni demo",
      totalBookings: "Demo prenotate",
      colTime: "Orario",
      noBookings: "Nessuna prenotazione demo.",
      statusNew: "Nuovo",
      statusContacted: "Contattato",
      statusWon: "Cliente",
      markContacted: "Contattato",
      markWon: "Cliente",
      delete: "Elimina",
    },
  },

  de: {
    code: "de",
    nav: {
      products: "Produkte",
      features: "Funktionen",
      pricing: "Preise",
      manifesto: "Manifest",
      contact: "Kontakt",
      demo: "Demo",
      cta: "Demo anfragen",
      admin: "Admin-Bereich",
    },
    hero: {
      overline: "SUITE COMPLETA ED OPERATIVA PER LA RISTORAZIONE",
      line1: "Dein Restaurant,",
      line2: "synchronisiert",
      line3: "auf die Sekunde.",
      sub: "Lager, Personal und Küchen- und Bar-Bons in einem einzigen digitalen Organismus. SOR verwandelt das Chaos des Service in einen präzisen, messbaren und profitablen Fluss.",
      ctaPrimary: "Abo berechnen",
      ctaSecondary: "Produkte entdecken",
      stat1: "−31 % Lagerverschwendung",
      stat2: "3 Min. Ø Bon-Zeit",
      stat3: "100 % Service im Griff",
    },
    impact: {
      overline: "SOR IN ZAHLEN",
      germany: { value: 79, label: "Restaurants in Deutschland nutzen SOR heute" },
      world: { value: 159, label: "Restaurants weltweit" },
      saved: { start: 4870000, label: "Von unseren Kunden eingesparte Euro", prefix: "€" },
      sara: {
        tag: "KÜNSTLICHE INTELLIGENZ",
        name: "S.A.R.A",
        title: "Die gesamte Restaurantstruktur unter Kontrolle der weltweit fortschrittlichsten KI",
        body: "S.A.R.A überwacht jeden Bereich in Echtzeit. Über Kameras misst sie die tatsächlichen Zubereitungszeiten in der Küche, beobachtet die Leistung der Köche und stellt sicher, dass jedes Gericht stets identisch zum Standard herauskommt. Nichts entgeht ihr: konstante Qualität, tadelloser Service.",
        points: [
          "Echte Zubereitungszeiten per Kamera überwacht",
          "Leistung jedes Kochs unter kontinuierlicher Analyse",
          "Qualitätskontrolle: jedes Gericht immer gleich beim Servieren",
        ],
      },
      sensing: {
        tag: "SARA SENSING",
        title: "Das Restaurant, das wahrnimmt. Ohne Kameras.",
        body: "Sara Sensing verwandelt die WiFi-Signale deines Lokals in Präsenz- und Vitaldatenerkennung – durch Wände hindurch, ohne Kameras und ohne tragbare Geräte. Die vom WiFi ausgesendeten Mikrowellen werden zu einem unsichtbaren Radar, das alles wahrnimmt, was im Restaurant passiert.",
        detects: [
          { t: "Präsenz & Belegung", d: "Zählt Personen und verfolgt Ein- und Ausgänge in jedem Raum." },
          { t: "Atmung & Herzschlag", d: "Kontaktlose Erfassung der Vitalparameter, ganz ohne Berührung." },
          { t: "Bewegungen & Übergänge", d: "Folgt Bewegungen und Wechseln von einem Raum zum anderen." },
          { t: "Semantische Zustände", d: "Erkennt, ob jemand schläft, ein Raum aktiv oder das Bad belegt ist." },
          { t: "Sicherheit & Alarm", d: "Erkennt Sturzrisiko oder fehlende Bewegung und schlägt Alarm." },
        ],
      },
    },
    marquee: "LAGERVERWALTUNG · TEAM MANAGER · KITCHEN DISPLAY · BAR BOARD · LIVE-BONS · SICHERE PIN · FOOD COST · SCHICHTEN · ",
    productsSection: {
      overline: "DAS ÖKOSYSTEM",
      title: "Drei Apps. Ein einziges Gehirn.",
      sub: "Jedes Modul arbeitet allein oder gemeinsam. Du aktivierst nur, was du brauchst, und zahlst nur die genutzten Stunden.",
      whyLabel: "Warum es wichtig ist",
      onlyLabel: "Nur SOR kann das",
      featuresLabel: "Was es macht",
    },
    products: [
      {
        id: "gestionale",
        domain: "gestionale.sor.de",
        name: "Warenwirtschaft",
        tagline: "Das Lager, das sich selbst zählt.",
        description:
          "Volle Kontrolle über Bestände, Lieferanten und Food Cost in Echtzeit. Du weißt immer, was du hast, was fehlt und was jeder Teller kostet.",
        features: [
          { title: "Bestand in Echtzeit", desc: "Jeder Zu- und Abgang aktualisiert die Bestände sofort – ohne Excel." },
          { title: "Food Cost pro Gericht", desc: "Die exakten Kosten jedes Rezepts, neu berechnet bei jeder Preisänderung." },
          { title: "Intelligente Bestellungen", desc: "Automatische Mindestbestände und Bestellvorschläge nach echtem Verbrauch." },
          { title: "Haltbarkeit & HACCP", desc: "Chargen, Ablaufdaten und Rückverfolgbarkeit – bereit für jede Kontrolle." },
        ],
        whyMatters:
          "Die Marge eines Restaurants wird im Lager gewonnen oder verloren. Ohne genaue Daten ist jeder Teller ein Glücksspiel: unsichtbare Verschwendung und ein Food Cost, der Monat für Monat den Gewinn auffrisst.",
        onlyUs:
          "Nur SOR verbindet das Lager direkt mit den Küchen-Bons: Jedes servierte Gericht bucht die Zutaten automatisch ab. Keine Doppeleingaben, immer korrekter Bestand.",
      },
      {
        id: "team",
        domain: "team.sor.de",
        name: "Team Manager",
        tagline: "Dein Team, orchestriert.",
        description:
          "Schichten, Anwesenheit und Kommunikation in einem Terminal. Admins planen, Mitarbeiter stempeln mit persönlicher PIN.",
        features: [
          { title: "Schichten per Drag & Drop", desc: "Baue die Woche in Minuten – das Team sieht sie sofort am Handy." },
          { title: "Stempeln mit PIN", desc: "Kommen und Gehen am Terminal, ohne verlierbare Ausweise." },
          { title: "Personalkosten live", desc: "Sieh in Echtzeit, was jeder Service im Verhältnis zum Umsatz kostet." },
          { title: "Urlaub & Abwesenheit", desc: "Anträge, Freigaben und Stundenkonten ohne eine einzige WhatsApp." },
        ],
        whyMatters:
          "Personal ist der größte und am schwersten kontrollierbare Kostenblock. Handgemachte Schichten erzeugen Lücken, unbezahlte Überstunden und Konflikte, die die Besten vertreiben.",
        onlyUs:
          "Nur SOR verknüpft die Personalkosten mit dem echten Bon-Verlauf: Leert sich der Saal, warnt dich das System, dass du genau jetzt zu viel ausgibst.",
      },
      {
        id: "kitchen",
        domain: "pac.sor.de/kitchen",
        name: "PAC · Kitchen Board",
        tagline: "Die Küche, die keinen Bon verliert.",
        description:
          "Das Kitchen Display System, das den Papierbon ersetzt. Bons kommen sortiert, nach Priorität eingefärbt und getaktet an.",
        features: [
          { title: "Live-Bons pro Station", desc: "Jeder Posten sieht nur seine Gerichte, in der richtigen Ausgabereihenfolge." },
          { title: "Timer & Verzug in Farben", desc: "Die Zubereitungszeit wird grün, gelb, rot: kein vergessener Tisch." },
          { title: "Bump & Recall sofort", desc: "Ein Tipp zum Abschließen, ein Tipp zum Zurückholen. Kein Papier, keine Fehler." },
          { title: "Saal-Küche-Synchronität", desc: "Änderungen, Allergen-Notizen und Teilrechnungen kommen sauber am Screen an." },
        ],
        whyMatters:
          "In der Küche ist jede verlorene Sekunde ein kalt werdender Tisch. Papierbons gehen verloren, reißen und sagen nie, wie viel Zeit wirklich vergangen ist.",
        onlyUs:
          "Nur SOR stoppt jedes Gericht ab der Bestellung und lernt deine echten Zeiten – es zeigt, wo der Service langsamer wird, bevor der Gast es merkt.",
      },
      {
        id: "bar",
        domain: "pac.sor.de/bar",
        name: "PAC · Bar Board",
        tagline: "Der Tresen, immer einen Schritt voraus.",
        description:
          "Das Display für die Bar: Cocktails, Kaffee und Getränke in einer eigenen Warteschlange, getrennt von der Küche, mit denselben Tempo-Regeln.",
        features: [
          { title: "Eigene Bar-Warteschlange", desc: "Getränke warten nicht auf Gerichte: sie kommen im Takt des Tresens." },
          { title: "Aperitif-Priorität", desc: "Schnelle Orders und Mehrfachrunden werden automatisch erkannt und gruppiert." },
          { title: "Rezepte am Screen", desc: "Mengen und Zubereitung der Cocktails immer sichtbar für den Barkeeper." },
          { title: "Sync mit der Rechnung", desc: "Jedes servierte Getränk steht sofort auf der Tischrechnung, ohne Neueingabe." },
        ],
        whyMatters:
          "Die Bar bringt die höchsten Margen, erzeugt aber auch die Schlange, die den Abend ruiniert. Ohne eigenen Fluss verstopfen sich Küche und Tresen gegenseitig.",
        onlyUs:
          "Nur SOR trennt den Bar-Fluss physisch vom Küchen-Fluss und hält sie auf derselben Rechnung: zwei Geschwindigkeiten, ein perfekter Bon.",
      },
    ],
    manifesto: {
      overline: "DAS MANIFEST",
      title: "Warum es SOR gibt",
      chapters: [
        { n: "01", title: "Daten vor Bauchgefühl", body: "Ein Restaurant führt man nicht nach Gefühl. Jede Entscheidung – eine Bestellung, eine Schicht, ein Gericht – braucht eine echte, sekundengenaue Zahl." },
        { n: "02", title: "Ein System, nicht zehn Apps", body: "Lager, Personal und Bons sprechen dieselbe Sprache. Fragmentierung ist der wahre Feind der Marge." },
        { n: "03", title: "Zahle, was du nutzt", body: "Keine aufgeblähten Jahreslizenzen. Aktiviere die Stunden, die du brauchst, und schalte sie in der Nebensaison ab." },
        { n: "04", title: "Tempo als Kultur", body: "Die Software muss im Service verschwinden: ein Tipp, ein Bon, ein Teller. Alles andere ist Lärm." },
      ],
    },
    testimonials: {
      overline: "STIMMEN AUS DEM GASTRAUM",
      title: "Restaurants, die nicht mehr zurückwollen",
      items: [
        { quote: "Seit die Küche mit dem Kitchen Board arbeitet, haben wir die Ausgabezeiten um 40 % gesenkt. Niemand ruft mehr Bons durch – man liest einfach den Screen.", author: "Luca Ferrari", role: "Inhaber", restaurant: "Osteria del Porto", city: "Hamburg", rating: 5 },
        { quote: "Der Food Cost pro Gericht in Echtzeit hat mir die Augen geöffnet: drei Gerichte waren Verlustbringer. In einem Monat hatte ich das Abo wieder drin.", author: "Sofia Greco", role: "Küchenchefin & Inhaberin", restaurant: "Marea Bistrot", city: "Berlin", rating: 5 },
        { quote: "Mit dem Team Manager stehen die Schichten in zwanzig Minuten und ich sehe sofort, was jeder Abend kostet. Apps stundenweise zu zahlen ist genial.", author: "Marco Bianchi", role: "General Manager", restaurant: "Trattoria 1985", city: "München", rating: 5 },
        { quote: "An der Bar gab es ständig lange Schlangen. Mit dem eigenen Bar Board servieren wir Aperitifs doppelt so schnell – auf derselben Rechnung.", author: "Elena Rossi", role: "Bar Managerin", restaurant: "Laguna Cocktail Bar", city: "Köln", rating: 5 },
      ],
    },
    pricing: {
      overline: "RECHNER",
      title: "Stell dein Stunden-Abo zusammen",
      sub: "Wähle die Apps, lege Stunden pro Tag und Tage pro Woche fest. Der Preis richtet sich nach echter Nutzung – ab 2 €/Stunde.",
      selectApps: "Apps auswählen",
      hoursPerDay: "Stunden pro Tag",
      daysPerWeek: "Tage pro Woche",
      billing: "Abrechnung",
      weekly: "Wöchentlich",
      monthly: "Monatlich",
      perHour: "/Std.",
      estimateLabel: "Dein Angebot",
      savingsLabel: "Geschätzte Ersparnis/Monat",
      netLabel: "Netto-Vorteil/Monat",
      monthlyHoursLabel: "Betriebsstunden pro Monat",
      savingsHint: "Schätzung basierend auf den monatlichen Nutzungsstunden: weniger Verschwendung, effizientere Küche und optimierte Personalkosten.",
      weeklyCost: "Wochenkosten",
      monthlyCost: "Monatskosten",
      hours: "Std.",
      days: "Tage",
      noApps: "Wähle mindestens eine App für ein Angebot.",
      requestCta: "Diesen Plan anfragen",
      breakdown: "Details",
      plansTitle: "Oder starte mit einem fertigen Paket",
      plansSub: "Empfohlene Konfigurationen, jederzeit stundenweise anpassbar.",
      mostPopular: "Beliebteste",
      includes: "Enthält",
      choosePlan: "Wählen",
    },
    plans: {
      starter: { name: "Starter", desc: "Lagerkontrolle für den Einstieg." },
      team: { name: "Team", desc: "Lager + komplette Personalverwaltung." },
      kitchen: { name: "Kitchen Pro", desc: "Kitchen Display für deine Küche dazu." },
      full: { name: "Full Suite", desc: "Alles, Küche und Bar synchron." },
    },
    appNames: {
      gestionale: "Warenwirtschaft",
      team: "Team Manager",
      kitchen: "Kitchen Board",
      bar: "Bar Board",
    },
    contact: {
      overline: "SPRECHEN WIR",
      title: "Hol SOR in dein Restaurant",
      sub: "Hinterlasse deine Daten: Wir bereiten eine maßgeschneiderte Demo vor und zeigen dir das genaue Angebot für deinen Betrieb.",
      name: "Vor- und Nachname",
      email: "E-Mail",
      phone: "Telefon",
      restaurant: "Name des Restaurants",
      message: "Erzähl uns von deinen Anforderungen",
      submit: "Anfrage senden",
      sending: "Wird gesendet...",
      success: "Anfrage gesendet! Wir melden uns in Kürze.",
      error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
      estimateNote: "Angebot aus dem Rechner beigefügt",
    },
    booking: {
      overline: "DEMO BUCHEN",
      title: "Reserviere dein Zeitfenster",
      sub: "Wähle Tag und Uhrzeit: Ein Berater zeigt dir SOR live, mit S.A.R.A in Aktion.",
      dateLabel: "Tag wählen",
      timeLabel: "Uhrzeit wählen",
      name: "Vor- und Nachname",
      email: "E-Mail",
      restaurant: "Restaurant",
      notes: "Notizen (optional)",
      submit: "Demo buchen",
      sending: "Wird gebucht...",
      success: "Demo gebucht! Wir bestätigen per E-Mail.",
      error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
      selectDatePrompt: "Wähle ein Datum im Kalender",
      selectTimePrompt: "Wähle eine verfügbare Uhrzeit",
      chosen: "Deine Auswahl",
      slotTaken: "Belegt",
    },
    footer: {
      tagline: "Betriebs-Suite für die Gastronomie.",
      rights: "Alle Rechte vorbehalten.",
      product: "Produkt",
      company: "Unternehmen",
    },
    admin: {
      title: "Admin-Bereich",
      pinPrompt: "PIN eingeben zum Fortfahren",
      pin: "PIN",
      enter: "Anmelden",
      wrongPin: "Ungültige PIN",
      dashboard: "Lead-Dashboard",
      totalLeads: "Leads gesamt",
      newLeads: "Neu",
      potentialRevenue: "Potenzieller Umsatz/Monat",
      appInterest: "Interesse an Apps",
      leadsList: "Eingegangene Anfragen",
      colName: "Name",
      colContact: "Kontakt",
      colRestaurant: "Restaurant",
      colApps: "Apps",
      colEstimate: "Angebot",
      colStatus: "Status",
      colDate: "Datum",
      colActions: "Aktionen",
      logout: "Abmelden",
      noLeads: "Noch keine Anfragen.",
      bookingsList: "Demo-Buchungen",
      totalBookings: "Gebuchte Demos",
      colTime: "Uhrzeit",
      noBookings: "Keine Demo-Buchungen.",
      statusNew: "Neu",
      statusContacted: "Kontaktiert",
      statusWon: "Kunde",
      markContacted: "Kontaktiert",
      markWon: "Kunde",
      delete: "Löschen",
    },
  },
};
